<div *ngIf="selectedFilters && selectedFilters.length > 0"
	 class="flex flex-wrap w-full justify-center items-center mb-3 gap-1">
	<ng-container *ngFor="let filter of selectedFilters">
			<ng-container *ngIf="filter.type !== 'range' && filter.option && !this.categories.includes(filter.option.value.toLowerCase())">
				<div class="fb-control-btn bg-[#fcf4e8] text-[12px] rounded-lg px-2 py-1
					border border-[#75787F]/20 cursor-pointer flex gap-1 items-center justify-center"
					 (click)="clearFilter(filter)">
					<span *ngIf="filter.type !== 'csv'">{{filter.option.value.toLowerCase()}}</span>
					<span *ngIf="filter.type === 'csv'">{{filter.option.displayName?.toLowerCase()}}</span>
					<span *ngIf="showClearFilterButton"
						  class="material-symbols-outlined ">
						close
					</span>
				</div>
			</ng-container>
			<ng-container *ngIf="filter.type === 'range'">
				<div>
					<span *ngIf="filter.range">{{filter.name.toLowerCase()}} : {{filter.range.value1}} - {{filter.range.value2}}</span>
					<span *ngIf="showClearFilterButton"
						  class="material-symbols-outlined ">
						close
					</span>
				</div>
			</ng-container>
	</ng-container>

	<button (click)="clearAllFilterOption()"
			class="fb-clear-btn text-[12px] bg-white rounded-lg px-2 py-1
				border border-[#75787F]/20 cursor-pointer flex gap-1 items-center justify-center"
			*ngIf="showClearFilterButton && showClearFilterButtonForCategory">
		clear
		<span class="material-symbols-outlined ">
				close
			</span>
	</button>
</div>
